<template>
  <span
    v-html="spaceChars"
    class="skeletons-TextSkeleton bg-skeleton leading-skeleton"
    :class="{'animate-pulse': pulse}"
    data-test="characters"
  />
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  /**
   * Number of character spaces to put in each word.
   */
  characters: {
    type: Number,
    required: false,
    default: 10
  },
  /**
   * Number of words to put in as a placeholder.
   * Basically it allows us width without needing to specify
   * a width.
   */
  words: {
    type: Number,
    required: false,
    default: 1
  },
  /**
   * When pulse is true and used within another skeleton
   * component, the pulsing increases.
   *
   * If this component is used on its own somewhere, it won't
   * pulse unless this is true.
   */
  pulse: {
    type: Boolean,
    required: false,
    default: false
  }
})

const spaceChars = computed(() => `${'&nbsp;'.repeat(props.characters)} `.repeat(props.words))
</script>
